module.exports = __webpack_public_path__ + "img/ultimas-unidades-garrafas.e496d15.png";